import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title, Pagination } from 'common/components/layout';
import { productListEvent } from 'common/helpers/customEvents';
import {
  pageFromQuery
  // queryStringFromProps
} from 'common/helpers/searchHelper';
import { getCollectionBySlug } from 'redux/collections/reducers';
import { listProducts } from 'redux/products/actions';

import Template from './components/ProductListTemplate';
import { listTemplate } from './defaultTemplates';

class ProductList extends Component {
  componentDidMount() {
    const { props } = this;
    const page = pageFromQuery(props.location.search);
    // const urlString = queryStringFromProps(props);
    this.listProducts(page);
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (prevProps.match.params.slug !== props.match.params.slug) {
      this.listProducts();
    }
    if (prevProps.location.search !== props.location.search) {
      const page = pageFromQuery(props.location.search);
      this.listProducts(page);
    }
  }

  pushPage = (page) => {
    const { props } = this;
    const { slug } = props.match.params;
    const parsed = queryString.parse(props.location.search);
    if (page && page > 1) {
      parsed.page = page;
      const stringified = queryString.stringify(parsed);
      props.history.push(`/collection/${slug}?${stringified}`);
    } else {
      delete parsed.page;
      const stringified = queryString.stringify(parsed);
      props.history.push(`/collection/${slug}?${stringified}`);
    }
  };

  listProducts = (page) => {
    const { props } = this;
    const { slug } = props.match.params;
    const parsed = queryString.parse(props.location.search);
    let qString = '';
    if (parsed.wineType) {
      qString += `&wineType=${parsed.wineType}`;
    }
    if (parsed.wineVarietal) {
      qString += `&wineVarietal=${parsed.wineVarietal}`;
    }
    if (parsed.wineCountryCode) {
      qString += `&wineCountryCode=${parsed.wineCountryCode}`;
    }
    if (parsed.wineRegion) {
      qString += `&wineRegion=${parsed.wineRegion}`;
    }
    if (parsed.wineAppellation) {
      qString += `&wineAppellation=${parsed.wineAppellation}`;
    }
    if (parsed.vendorId) {
      qString += `&vendorId=${parsed.vendorId}`;
    }
    if (parsed.fromPrice) {
      qString += `&fromPrice=${parsed.fromPrice}`;
    }
    if (parsed.toPrice) {
      qString += `&toPrice=${parsed.toPrice}`;
    }
    if (qString.length === 0) {
      qString = undefined;
    }
    props.listProducts(slug, qString, page, 'List');
  };

  render() {
    const { settings, collection, products, location } = this.props;
    const page = pageFromQuery(location.search);
    if (!settings.data || !collection) {
      return (
        <Layout title="" loading>
          &nbsp;
        </Layout>
      );
    }
    const productArray = collection.productIds.map((productId) => {
      const product = products.data[productId];
      return product;
    });
    const newTemplate = collection.productTemplate || listTemplate;
    productListEvent(collection);
    return (
      <Layout
        title={collection.seo.title}
        description={collection.seo.description}
      >
        <Title>{collection.title}</Title>
        <div dangerouslySetInnerHTML={{ __html: collection.content }} />
        <div className="c7-product-collection">
          <Template
            products={productArray}
            template={newTemplate}
            settings={settings}
            collection={collection}
          />
          <Pagination
            totalRecords={collection.productCount}
            page={page || 1}
            search={this.pushPage}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  collection: getCollectionBySlug(state.collection, ownProps.match.params.slug),
  collectionProductCount: state.collection.recordCount,
  products: state.product,
  settings: state.setting
});

export default connect(mapStateToProps, {
  listProducts
})(ProductList);
